type FinancialQuery = {
  data?: { cache?: { computedAt: string } }
  dataUpdatedAt: number
}

export function oldestFinancialComputation(queries: FinancialQuery[]): number {
  const timestamps = queries
    .filter((query) => query.data !== undefined)
    .map((query) =>
      query.data?.cache ? Date.parse(query.data.cache.computedAt) : query.dataUpdatedAt,
    )
  return timestamps.length ? Math.min(...timestamps) : 0
}
